angular.module('bmsApp.merrymaids.job')
	.factory('MMJobSvc', [
		'$q',
		'$rootScope',
		'$modal',
		'notify',
		'CRUDSvc',
		'MM_JOB_API',
		function ($q,
				  $rootScope,
				  $modal,
				  notify,
				  CRUDSvc,
				  MM_JOB_API) {

			function preferredCleaningTimeTypeOptions() {
				var deferred = $q.defer();

				// spoof response
				var response = {
					data: {
						success: true,
						message: '',
						options: [
							{
								value: 'Anytime Clean',
								label: 'Anytime Clean'
							},
							{
								value: 'AM',
								label: 'AM'
							},
							{
								value: 'PM',
								label: 'PM'
							},
							{
								value: 'Specific',
								label: 'Specific'
							}
						]
					}
				};

				deferred.resolve(response);

				return deferred.promise;
			}

			function jobCancelReasonOptions(params) {
				return CRUDSvc.get('api/merrymaids/job/cancel-reason/options', params);
			}

			function updateRotationCounts(job) {
				var cleanRotationCount = 0;
				var deepCleanRotationCount = 0;
				var jobRooms = job.job_rooms || [];
				angular.forEach(jobRooms, function (jobRoom) {
					var cleanRotations = jobRoom.clean_rotations || [];
					var deepCleanRotations = jobRoom.deep_clean_rotations || [];
					cleanRotationCount = Math.max(cleanRotationCount, cleanRotations.length);
					deepCleanRotationCount = Math.max(deepCleanRotationCount, deepCleanRotations.length);
				});
				job.clean_rotation_count = cleanRotationCount;
				job.deep_clean_rotation_count = deepCleanRotationCount;
			}

			function showCancelJobModal(job) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/merrymaids/job/templates/MMCancelJobModal.html',
					controller: 'MMCancelJobModalCtrl',
					controllerAs: 'CancelJob',
					size: 'md',
					scope: $rootScope,
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						job: function () {
							return angular.copy(job);
						}
					}
				});

				modalInstance.result.then(function (result) {
					if (result.success === true) {
						notify({
							message: 'Job cancelled successfully'
						});
					}
					else {
						notify({
							message: result.error,
							classes: 'error'
						});
					}
				}, function () {
					// closed
				});

				return modalInstance.result;
			}

			function showReactivateJobsModal(customer) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/merrymaids/job/templates/MMReactivateJobsModal.html',
					controller: 'MMReactivateJobsModalCtrl',
					controllerAs: 'ReactivateJobs',
					size: 'md',
					scope: $rootScope,
					backdrop: 'static', //disable click-outside closing modal
					resolve: {
						customer: function () {
							return angular.copy(customer);
						}
					}
				});

				modalInstance.result.then(function (result) {
					if (result.success === true) {
						notify({
							message: 'Job(s) reinstated successfully'
						});
					}
					else {
						notify({
							message: result.error,
							classes: 'error'
						});
					}
				}, function () {
					// closed
				});

				return modalInstance.result;
			}

			function bulkInactive(params) {
				return CRUDSvc.post('api/merrymaids/job/bulk-inactive', params);
			}

			var self = {
				close: {
					index: function (params) {
						return CRUDSvc.get('api/merrymaids/job/close-jobs', params);
					},
				},
				index: function (params) {
					return CRUDSvc.get(MM_JOB_API.INDEX, params);
				},
				save: function (job) {
					var copy = angular.copy(job);
					if (moment.isMoment(copy.preferred_cleaning_time)) {
						copy.preferred_cleaning_time = copy.preferred_cleaning_time.format('HH:mm:ss');
					}
					return CRUDSvc.post(MM_JOB_API.SAVE, copy);
				},
				read: function (id, params) {
					return CRUDSvc.get(MM_JOB_API.READ + id, params);
				},
				delete: function (id) {
					return CRUDSvc.get(MM_JOB_API.DELETE + id);
				},
				cancel: function (params) {
					return CRUDSvc.post('api/merrymaids/job/cancel', params);
				},
				reactivateOptions: function (params) {
					return CRUDSvc.get('api/merrymaids/job/reactivate-options', params);
				},
				reactivate: function (params) {
					return CRUDSvc.post('api/merrymaids/job/reactivate', params);
				},
				quotesByCustomer: function (customerId, params) {
					var newParams = angular.extend({}, params, {
						filter: {
							converted: false,
							customer: customerId
						}
					});
					return CRUDSvc.get(MM_JOB_API.INDEX, newParams);
				},
				quotesByCustomerOrCustomerEnquiry: function (customerId, params) {
					var newParams = angular.extend({}, params, {
						filter: {
							//converted: false,
							customerOrCustomerEnquiry: customerId
						}
					});
					return CRUDSvc.get(MM_JOB_API.INDEX, newParams);
				},
				jobsByCustomer: function (customerId, params) {
					var newParams = angular.extend({}, params, {
						filter: {
							converted: true,
							customer: customerId
						}
					});
					return CRUDSvc.get(MM_JOB_API.INDEX, newParams);
				},
				advantageProgrammePeriodOptions: function () {
					var deferred = $q.defer();

					// spoof response
					var response = {
						data: {
							success: true,
							message: '',
							options: [
								{
									value: 0,
									label: 'Do not join'
								},
								{
									value: 4,
									label: '4 Week Programme'
								},
								{
									value: 8,
									label: '8 Week Programme'
								},
								{
									value: 16,
									label: '16 Week Programme'
								},
								{
									value: 24,
									label: '24 Week Programme'
								}
							]
						}
					};

					deferred.resolve(response);

					return deferred.promise;
				},
				jobHistory: function (id, params) {
					return CRUDSvc.get(MM_JOB_API.JOB_HISTORY + id, params);
				},
				preferredCleaningTimeTypeOptions: preferredCleaningTimeTypeOptions,
				jobCancelReasonOptions: jobCancelReasonOptions,
				updateRotationCounts: updateRotationCounts,
				showCancelJobModal: showCancelJobModal,
				showReactivateJobsModal: showReactivateJobsModal,
				bulkInactive: bulkInactive,
				export: function(params) {
					var newParams = angular.extend({}, params, {
						'format': 'csv'
					});
					var query = $.param(newParams);
					window.open(MM_JOB_API.INDEX + '?' + query);
				},
			};
			return self;

		}
	])
	.constant('MM_JOB_API', {
		INDEX: 'api/merrymaids/job/index',
		SAVE: 'api/merrymaids/job/save',
		READ: 'api/merrymaids/job/read/',
		DELETE: 'api/merrymaids/job/delete/',
		JOB_HISTORY: 'api/merrymaids/job/history/'
	});
